import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'comment',
    initialState: {
        list: [],
    },
    reducers: {
        setCommentList(state, action) {
            state.list = action.payload
        },
        addComment(state, action) {
            state.list.unshift(action.payload)
        },
    }
})

export default slice.reducer

export const {
    setCommentList,
    addComment,
} = slice.actions